import React, { PropsWithChildren } from 'react';

interface ComponentProps {
  icon: JSX.Element;
}

const IconBlock: React.FC<PropsWithChildren<ComponentProps>> = ({ icon, children }) => {
  return (
    <>
      <div className="flex flex-row items-start gap-2">
        <div className="flex translate-y-[16%]">{icon}</div>
        <div className="flex flex-col gap-x-1">{children}</div>
      </div>
    </>
  );
};

export default IconBlock;
